import { indicar_ensino_fase_de_destino } from "./indicar-ensino-fase-de-destino";

const educacao_especial = [...indicar_ensino_fase_de_destino];

export { educacao_especial };
